import { InputTextElement } from '@app/common';
import TextWithReferences from '../../TextWithReferences/TextWithReferences';
import RequiredAsterisk from '../RequiredAsterisk';

type Properties = {
    data: InputTextElement;
    value?: string;
    setValue: (value: string) => void;
};

const InputText = (props: Properties) => {
    let inputEl: JSX.Element;
    if (props.data.multiline === true) {
        inputEl = (
            <textarea
                onChange={ev => props.setValue(ev.target.value)}
                value={props.value || ''}
            />
        );
    } else {
        inputEl = (
            <input
                type="text"
                onChange={ev => props.setValue(ev.target.value)}
                value={props.value || ''}
            />
        );
    }
    
    return (
        <p className="page-input page-input-text">
            <label><TextWithReferences text={props.data.label || ''}/><RequiredAsterisk required={props.data.required} /></label>
            {inputEl}
        </p>
    );
};
export default InputText;